__turbopack_context__.v({
  "MovieTitle": "s0FVmW_MovieTitle",
  "Tags": "s0FVmW_Tags",
});
